import styled from 'styled-components';
import {
  md_mobile_breakpoint,
  lg_mobile_breakpoint,
  desktop_breakpoint,
  tablet_landscape_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import colors from 'pubweb-smokey/dist/colors';

export const PlannerStyled = styled.div`
  margin: 48px auto;
  .planner-landing-header {
    color: ${colors.primary.claytonBlue.standard};
    font-family: acumin-pro, sans-serif;
    font-size: 34px;
    font-weight: 700;
    letter-spacing: -0.3px;
    line-height: 40px;
    margin: 0 auto 8px auto;
    width: 290px;
  }
  .planner-landing-subheader {
    color: ${colors.primary.claytonBlue.standard};
    font-family: acumin-pro, sans-serif;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.35px;
    line-height: 26px;
    margin: 0 auto 35px auto;
    width: 290px;
  }
  .planner-landing-linebreak {
    display: none;
  }
  .planner-landing-info {
    position: absolute;
    z-index: 2;
    top: 595px;
    margin-left: 37.5%;
    width: 170px;
    .planner-info-blurb {
      color: ${colors.primary.white.tint};
      font-family: source-sans-pro, sans-serif;
      font-size: 14px;
      line-height: 22px;
    }
  }
  .planner-landing-cta {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
    margin: auto auto 25px;
    button {
      border-radius: 2px;
      font-family: source-sans-pro, sans-serif;
      font-size: 14px;
      font-weight: 600;
      height: 50px;
      letter-spacing: 1px;
      line-height: 16px;
      padding: 17px;
      width: 135px;
    }
  }
  .planner-landing-hero-image {
    background-image: url(${(props) => props.imageBackground?.smallMobile});
    background-repeat: no-repeat;
    background-size: contain;
    height: 575px;
    margin: 0 auto 50px;
    width: 298px;
  }
  .planner-landing-badges {
    display: none;
  }
  .planner-landing-hero-background {
    position: absolute;
    background-color: ${colors.primary.claytonBlue.standard};
    height: 165px;
    margin: 47px auto 0 auto;
    top: 340px;
    width: 100%;
    z-index: -1;
  }
  @media screen and (min-width: ${md_mobile_breakpoint}px) {
    .planner-landing-info {
      .planner-info-blurb {
        width: 191px;
      }
    }
  }
  @media screen and (min-width: ${lg_mobile_breakpoint}px) {
    .planner-landing-header
      .planner-landing-subheader
      button.planner-landing-cta {
      width: 311px;
    }
    .planner-landing-info {
      margin-left: 40%;
    }
    .planner-landing-hero-image {
      background-image: url(${(props) => props.imageBackground?.largeMobile});
      height: 600px;
      margin-bottom: -7rem;
    }
    .planner-landing-hero-background {
      height: 170px;
    }
  }
  @media screen and (min-width: 620px) {
    .planner-landing-info {
      margin-left: 240px;
    }
  }
  @media screen and (min-width: ${desktop_breakpoint - 1}px) {
    .planner-landing-info {
      margin-left: 39%;
      top: 700px;
      .planner-info-blurb {
        font-size: 16px;
        width: 230px;
      }
    }
    .planner-landing-hero-image {
      background-image: url(${(props) => props.imageBackground?.tablet});
      background-position: center;
      height: 700px;
      margin-bottom: unset;
      width: 612px;
    }
    .planner-landing-hero-background {
      height: 240px;
      top: 360px;
    }
  }
  @media screen and (min-width: ${tablet_landscape_breakpoint}px) {
    margin-top: unset;
    .constrained-width {
      display: flex;
      flex-direction: row;
      width: 1024px;
    }
    .planner-landing-content {
      background-color: ${colors.primary.white.standard};
      border-radius: 4px;
      display: block;
      height: 425px;
      margin: 130px 0 0 3rem;
      padding: 33px;
      width: 400px;
    }
    .planner-landing-header {
      font-size: 35px;
      letter-spacing: -0.35px;
      line-height: 30px;
      margin: 0 auto 25px 0;
    }
    .planner-landing-subheader {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: -0.3px;
      line-height: 20px;
      margin: 0 0 10px 1px;
    }
    .planner-landing-linebreak {
      display: block;
      border: 0.5px solid ${colors.primary.claytonBlue.standard};
      margin: 13px auto 34px 0;
    }
    .planner-landing-info {
      bottom: unset;
      display: block;
      font-family: source-sans-pro, sans-serif;
      font-size: 16px;
      line-height: 27px;
      margin-bottom: 24px;
      margin-left: unset;
      position: unset;
      width: unset;
      z-index: unset;
      .planner-info-blurb {
        width: 330px;
      }
    }
    .planner-landing-cta {
      justify-content: initial;
      margin: 25px auto 0;
    }
    .planner-landing-hero-image {
      background-image: url(${(props) => props.imageBackground?.desktop});
      margin: 5rem auto -4.5rem auto;
      z-index: 8;
    }
    .planner-landing-hero-background {
      height: 775px;
      position: absolute;
      top: 0;
      ::after {
        background-color: ${colors.secondary.navy1.standard};
        content: '';
        display: block;
        height: 50px;
        margin-bottom: -50px;
        position: absolute;
        bottom: 0;
        width: 100%;
        z-index: 8;
      }
    }
  }
  @media screen and (min-width: 1200px) {
    .constrained-width {
      width: 1200px;
    }
    .planner-landing-content {
      height: 425px;
      margin-bottom: 60px;
      margin-left: 75px;
      padding: 40px;
      width: 450px;
    }
    .planner-landing-info {
      width: 360px;
    }
    .planner-landing-cta {
      margin-top: 35px;
    }
  }
  @media screen and (min-width: 1440px) {
    .constrained-width {
      width: 1400px;
    }
    .planner-landing-content {
      margin-left: 205px;
    }
    .planner-landing-info {
      width: 368px;
    }
    .planner-landing-hero-image {
      margin-right: 0;
    }
    .planner-landing-badges {
      display: block;
      position: relative;
      top: -3.5%;
      right: 16rem;
      z-index: 9;
      svg {
        height: 560px;
      }
    }
  }
`;

export default PlannerStyled;
